<template>
    <div class="shippingContainer margin_top_xl">
        <div class="row">
            <div class="col-lg-6">
                <h4 class="font-bold font-lg">Shipping Details</h4>
                <div class="margin_top_md">
                    <form action="#" @submit.prevent="submitAddress">
                        <div class="form-group">
                            <label class="control-label font-sm requiredField">Full Name</label>
                            <input type="text" v-model="formData.full_name" required class="form-control" placeholder="Full name">
                        </div>
                        <div class="form-group">
                            <label class="control-label font-sm requiredField">Email Address</label>
                            <input type="email" v-model="formData.email" required class="form-control" placeholder="Your email address">
                        </div>
                        <div class="form-group">
                            <label class="control-label font-sm requiredField">Phone Number</label>
                            <input type="text" class="form-control" v-model="formData.phone_no" required placeholder="Contact phone number">
                        </div>
                        <div class="form-group">
                            <label class="control-label font-sm requiredField">Address Line 1</label>
                            <input type="text" class="form-control" v-model="formData.address" required placeholder="street address">
                        </div>
                        <div class="row">
                            <div class="col-6">
                                <div class="form-group">
                                    <label class="control-label font-sm">Country</label>
                                    <select class="form-control">
                                        <option>Select Country</option>
                                        <option>Nigeria</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="form-group">
                                    <label class="control-label font-sm requiredField">State</label>
                                     <select class="form-control" :disabled="loadingStates" v-model="formData.state_id">
                                        <option v-if="loadingStates" value="">
                                            loading ...
                                        </option>
                                        <option v-else-if="states.length !== 0" value="">Select State</option>
                                        <option v-for="(st, index) in states" :key="index" :value="st.id">
                                            {{st.name}}
                                        </option>
                                    </select>
                                </div>
                            </div>

                        </div>
                        <div class="row">
                            <div class="col-6">
                                <div class="form-group">
                                    <label class="control-label font-sm requiredField">City/Town</label>
                                    <input type="text" v-model="formData.city" required class="form-control" placeholder="city/town">
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="form-group">
                                    <label class="control-label font-sm">Zip/Postal Code</label>
                                    <input type="text" v-model="formData.zip_code" class="form-control" placeholder="Enter zip code">
                                </div>
                            </div>
                        
                        </div>

                        <div class="form-group margin_bottom_lg">
                            <submit-button class="btn btn-secondary col-12" :disabled="checkField" :loading="submitting || creatingOrderPayment">
                                Continue to payment</submit-button>
                        </div>
                        
                    </form>
                </div>
            </div>
            <div class="col-lg-6">
                <order-summary :checkField="checkField" :creatingOrder="submitting" @makePayment="makePayment" />
            </div>
        </div>
    </div>
</template>

<script>
import OrderSummary from './OrderSummaryCart';
import { mapState } from 'vuex';
export default {
    props: ['order','addresses','creatingOrderPayment'],
    data() {
        return {
            formData: {
                email: '',
                full_name: '',
                phone_no: '',
                address: '',
                zip_code: '',
                city: '',
                state_id: '',
            },
            newOrder: '',
            submitting: false,
        }
    },
    computed: {
        ...mapState(['states','loadingStates','user']),
        ...mapState('offtaker',['cart']),
        checkField() {
            const { email, full_name, phone_no, address, city, state_id } = this.formData
            if(email === '' || full_name === '' || phone_no === '' || city === '' || address === '' || state_id === '') {
                return true;
            }
            return false;
        },
        orderId() {
            return this.$route.params.id
        },
        subTotal() {
            return this.cart.reduce((sum, item) => {
                return sum + (item.crop.agg_kg_price * item.quantity)
            }, 0)
        },
        tax() {
            return this.subTotal * 0.05
        },
        total() {
            return this.subTotal + this.tax
        },
    },
    methods: {
        makePayment() {
            this.submitAddress()
        },
        submitAddress() {
            this.submitting = true;
            this.addresses.length === 0 ? this.createAddress() : this.updateAddress();
        },
        createAddress() {
            this.$http.post('addresses', this.formData)
            .then((response) => {
                this.$log('Response ', response.data)
                if(this.orderId === 'false') {
                    this.createOrder();
                } else {
                    this.$router.push({
                        name: 'offtaker.orderpayment',
                        params: {
                            id: this.orderId
                        }
                    })
                }
            })
            .catch((error) => {
                this.$toastr.error(error);
                this.submitting = false
            })
        },
        updateAddress() {
            this.formData.user_id = this.user.id
            this.$http.put(`addresses/${this.addresses[0].id}`, this.formData)
            .then((response) => {
                this.$log('Response ', response.data)
                if(this.orderId === 'false') {
                    this.createOrder();
                    
                } else {
                    this.$router.push({
                        name: 'offtaker.orderpayment',
                        params: {
                            id: this.orderId
                        }
                    })
                }
            })
            .catch((error) => {
                this.$toastr.error(error)
                this.submitting = false;
            })
            
        },

        createOrder() {
            const obj = {
                shipping_amount: 0,
                tax_amount: this.tax
            }
            this.$http.post('crop_orders', obj)
            .then((response) => {
                this.newOrder = response.data;
                this.$log('Order created ', response.data)
                this.$router.push({
                    name: 'offtaker.orderpayment',
                    params: {
                        id: response.data.id
                    }
                })
            })
            .catch((error) => {
                this.$toastr.error(error)
            })
            .finally(() => {
                this.submitting = false;
            })
        },
        
        assignValues() {
            if(this.addresses.length !== 0 ) {
                const [x] = this.addresses;
                this.formData = {
                    email: x.email,
                    full_name: x.full_name,
                    phone_no: x.phone_no,
                    address: x.address,
                    zip_code: x.zip_code,
                    city: x.city,
                    state_id: x.state_id,
                }
            }
        }
    },
    
    mounted() {
        this.assignValues()
    },
    created() {
        
    },
    components: {
        OrderSummary
    }
}
</script>

<style>

</style>